import type { ImageTargetData } from '../types/xr8';

/** Resolve luminance image URL relative to the target JSON location in public/. */
export const normalizeImageTarget = (
    data: ImageTargetData,
    jsonUrl: string,
): ImageTargetData => {
    const baseDir = jsonUrl.replace(/\/[^/]+$/, '');
    const luminanceFile =
        data.resources?.luminanceImage ?? data.imagePath.split('/').pop() ?? '';

    const imagePath = `${window.location.origin}${baseDir}/${luminanceFile}`;

    return {
        ...data,
        imagePath,
    };
};

export const loadImageTarget = async (jsonUrl: string): Promise<ImageTargetData> => {
    const response = await fetch(jsonUrl);
    if (!response.ok) {
        throw new Error(`Failed to load image target: ${jsonUrl}`);
    }
    const data: ImageTargetData = await response.json();
    return normalizeImageTarget(data, jsonUrl);
};

export const configureXR8ImageTargets = (targets: ImageTargetData[]): void => {
    window.XR8?.XrController?.configure({
        imageTargetData: targets,
        disableWorldTracking: true,
    });
};
